import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector, submit } from 'redux-form'
// hooks
import { useModalData } from 'hooks/index'
// components
import Form from './components/Form'
import { CloseIcon } from 'components/UI/Icons'
import { Button, BUTTON_LAYOUTS, Modal } from 'components/UI'
// constants
import { Forms } from 'constants/forms'
import { Modals } from 'constants/modals'
import { IField } from 'types/graphql'
// views
import { ButtonsContainer, Container, Header } from './views'

type ModalData = { field: IField; name: string }

const selector = formValueSelector(Forms.RISK_TEMPLATE_FORM)

const TextFieldModal: React.FC = () => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { isOpen, field, name }
  } = useModalData<ModalData>({ modalType: Modals.TEXT_FIELD_CONTENT })

  const fieldValue: string = useSelector((state) => selector(state, name))

  const onSave = () => {
    dispatch(submit(Forms.TEXT_FIELD_FORM))
  }

  const onSubmit = (data: { value: string }) => {
    dispatch(change(Forms.RISK_TEMPLATE_FORM, name, data.value))

    hideModal()
  }

  const initialValues = {
    value: fieldValue
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal isOpen={isOpen} width='sm' hideModal={hideModal}>
      <Container>
        <Header>
          <span>{field?.label}</span>
          <CloseIcon onClick={hideModal} />
        </Header>

        <Form field={field} initialValues={initialValues} onSubmit={onSubmit} />

        <ButtonsContainer>
          <Button shadowLess type='button' onClick={onSave} layout={BUTTON_LAYOUTS.PURPLE}>
            Save
          </Button>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
            Cancel
          </Button>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

export default TextFieldModal
